import styled, { css } from 'styled-components'
import LoadingButton from '@mui/lab/LoadingButton'
import { marginHandler, MarginSpacing, paddingHandler } from 'commons/styles/spacing'

const sizeMap = {
  unset: 0,
  small: 16,
  medium: 24,
  large: 32,
  xlarge: 64,
}

export type ButtonSizes = keyof typeof sizeMap

const StyledButton = styled(LoadingButton)<{
  $uppercased?: boolean
  $margin?: MarginSpacing
  $size?: ButtonSizes
  $padding?: MarginSpacing
}>`
  ${marginHandler}

  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-087);
  line-height: 16px;
  text-align: center;
  vertical-align: middle;
  border-width: 1px !important;
  letter-spacing: 0.005em;

  ${({ variant, theme }) =>
    variant === 'contained'
      ? css`
          &:not(:disabled) {
            background-color: var(--fill-accent-primary-default) !important;
            color: ${theme.palette.common.white} !important;
            &:hover {
              background-color: var(--fill-accent-primary-hover) !important;
            }
          }
        `
      : css`
          &:not(:disabled) {
            color: var(--fill-accent-primary-default) !important;
          }
        `}

  min-width: ${({ $size, theme }) => theme.spacing(sizeMap[$size || 'unset'])};
  padding: 12px 16px;

  ${paddingHandler}

  ${({ $uppercased }) =>
    !$uppercased &&
    css`
      text-transform: none;
    `}
`

export { StyledButton }
